{
  "namespaceUris": [
    "http://opcfoundation.org/UA/",
    "http://opcfoundation.org/UA/MachineTool/",
    "http://opcfoundation.org/UA/Machinery/",
    "http://opcfoundation.org/UA/DI/",
    "http://opcfoundation.org/UA/IA/",
    "http://opcfoundation.org/UA/ECM/",
    "http://opcfoundation.org/UA/Machinery/Energy/"
  ],
  "header": {
    "nameVariable": {
      "variablePath": "3:Identification.3:ProductInstanceUri",
      "dataType": "String"
    },
    "modelVariable": {
      "variablePath": "3:Identification.3:Model",
      "dataType": "LocalizedText"
    }
  },
  "imagesConfig": {
    "imageDefaults": {
      "[\\s\\S]*": "machine.jpg"
    }
  },
  "stacklight": {
    "lampPlaceholders": [
      {
        "variablePath": "1:Monitoring.1:Stacklight",
        "reference": "49",
        "type": "4:1006"
      }
    ],
    "signalVariable": {
      "variablePath": "4:SignalOn",
      "dataType": "Boolean"
    },
    "signalOnValue": "true",
    "signalOffValue": "false",
    "colorVariable": {
      "variablePath": "4:SignalColor",
      "dataType": "SignalColor"
    },
    "colorValues": {
      "0": "off",
      "1": "red",
      "2": "green",
      "3": "blue",
      "4": "yellow",
      "5": "purple",
      "6": "cyan",
      "7": "white"
    },
    "sortingVariable": {
      "variablePath": "NumberInList",
      "dataType": "UInteger"
    }
  },
  "timeline": {
    "variable": {
      "variablePath": "1:Production.1:ActiveProgram.1:State.0:CurrentState.Number",
      "dataType": "UInt32"
    },
    "colorValues": {
      "0": "#eaeaea",
      "1": "#00b20e",
      "2": "#17a2b8",
      "3": "#ffc107",
      "4": "#ff4136"
    }
  },
  "sections": [
    {
      "id": "a095125dd5f0f09615c88d28501aca28",
      "title": "Identification",
      "rows": [
        {
          "id": "aa81bb687d91d66362f420beee140693",
          "elements": [
            {
              "id": "e053cabd9cedd5355d4998de961abdd2",
              "type": 0,
              "label": "Manufacturer",
              "valueVariable": {
                "variablePath": "3:Identification.3:Manufacturer",
                "dataType": "LocalizedText"
              }
            },
            {
              "id": "c8426a68a529932b30d76b765f383448",
              "type": 0,
              "label": "ProductUri",
              "showAsLink": true,
              "valueVariable": {
                "variablePath": "3:Identification.3:ProductInstanceUri",
                "dataType": "String"
              }
            },
            {
              "id": "390ac0b6f2d697b6cdcae653d7bc7867",
              "type": 0,
              "label": "Serial Number",
              "valueVariable": {
                "variablePath": "3:Identification.3:SerialNumber",
                "dataType": "String"
              }
            },
            {
              "id": "f9f8001cbc0e51437447aae03a6d1317",
              "type": 0,
              "label": "Software Revision",
              "valueVariable": {
                "variablePath": "3:Identification.3:SoftwareRevision",
                "dataType": "String"
              }
            },
            {
              "id": "5a3ac8b25c75972ebb886e3a88ee897e",
              "type": 0,
              "label": "Build Year",
              "valueVariable": {
                "variablePath": "3:Identification.2:YearOfConstruction",
                "dataType": "UInt16"
              }
            },
            {
              "id": "bb3c4e3e4b711214e29b2d89b92dbb45",
              "type": 0,
              "label": "Device Class",
              "valueVariable": {
                "variablePath": "3:Identification.3:DeviceClass",
                "dataType": "String"
              }
            },
            {
              "id": "caa7c510f43fe62277ff0d6d56eb5620",
              "type": 0,
              "label": "Location",
              "valueVariable": {
                "variablePath": "3:Identification.2:Location",
                "dataType": "String"
              }
            },
            {
              "id": "92fcfc1973029f3a8bb507891f3791b0",
              "type": 0,
              "label": "Model",
              "valueVariable": {
                "variablePath": "3:Identification.3:Model",
                "dataType": "LocalizedText"
              }
            },
            {
              "id": "59d343a5e30e62f78f301ebdc86b91c8",
              "type": 0,
              "label": "Product Code",
              "valueVariable": {
                "variablePath": "3:Identification.3:ProductCode",
                "dataType": "String"
              }
            }
          ]
        }
      ]
    },
    {
      "id": "bf19594d62f4d4cf2da654edc3cd4e81",
      "title": "Tools",
      "rows": [
        {
          "id": "d57a336efdfe15c2eda195cd71db60e8",
          "placeholders": [
            {
              "variablePath": "1:Equipment.1:Tools",
              "reference": "47",
              "type": "1:50"
            }
          ],
          "title": "Tools",
          "titleVariable": {
            "variablePath": "1:Name",
            "dataType": "String"
          },
          "elements": [
            {
              "id": "ad723e95efed695f422f27443ff9775d",
              "type": 0,
              "label": "Control Identifier Interpretation",
              "valueVariable": {
                "variablePath": "1:ControlIdentifierInterpretation",
                "dataType": "Enum",
                "enumValues": {
                  "0": "NumberBased",
                  "1": "GroupBased",
                  "2": "Other"
                }
              }
            },
            {
              "id": "3a181e8e9a93a112eb6b5eb77f97f73d",
              "type": 0,
              "label": "Identifier",
              "valueVariable": {
                "variablePath": "1:ControlIdentifier1",
                "dataType": "UInt32"
              }
            },
            {
              "id": "c3a86daf031d7160aa11da90e365d188",
              "type": 0,
              "label": "Name",
              "valueVariable": {
                "variablePath": "1:Name",
                "dataType": "String"
              }
            },
            {
              "id": "a78093d6284952ad19b147e25e948bec",
              "type": 2,
              "valueVariable": {
                "variablePath": "1:Locked",
                "dataType": "Boolean"
              },
              "badgeValues": [
                {
                  "backgroundColor": "#DC3545",
                  "textColor": "#ffffff",
                  "value": "true",
                  "label": "Locked"
                },
                {
                  "backgroundColor": "#198754",
                  "textColor": "#ffffff",
                  "value": "false",
                  "label": "Active"
                }
              ]
            }
          ]
        }
      ]
    },
    {
      "id": "dd849f15e90fb9736c710eec966c5bca",
      "title": "Active Program",
      "rows": [
        {
          "id": "693c5ca89bf7dbaa4b2673f6c0f7bcb9",
          "elements": [
            {
              "id": "9756e5cd54b07c68fe98b7ba99889d30",
              "type": 0,
              "label": "Name",
              "valueVariable": {
                "variablePath": "1:Production.1:ActiveProgram.1:Name",
                "dataType": "String"
              }
            },
            {
              "id": "8dfdd987acdd92afa167a98ddafe5b7e",
              "type": 0,
              "label": "State Id",
              "valueVariable": {
                "variablePath": "1:Production.1:ActiveProgram.1:State.CurrentState.Id",
                "property": "Id",
                "dataType": "Int"
              }
            },
            {
              "id": "3a64fad4f258fa373ab5b2071901d22b",
              "type": 2,
              "valueVariable": {
                "variablePath": "1:Production.1:ActiveProgram.1:State.CurrentState",
                "dataType": "LocalizedText"
              },
              "badgeValues": [
                {
                  "backgroundColor": "#eaeaea",
                  "textColor": "#000000",
                  "value": "Initializing"
                },
                {
                  "backgroundColor": "#00b20e",
                  "textColor": "#ffffff",
                  "value": "Running"
                },
                {
                  "backgroundColor": "#17a2b8",
                  "textColor": "#ffffff",
                  "value": "Ended"
                },
                {
                  "backgroundColor": "#ffc107",
                  "textColor": "#000000",
                  "value": "Interrupted"
                },
                {
                  "backgroundColor": "#ff4136",
                  "textColor": "#ffffff",
                  "value": "Aborted"
                }
              ]
            }
          ]
        }
      ]
    },
    {
      "id": "3c5336a1da1de83351a620cbf89e859f",
      "title": "Monitoring",
      "rows": [
        {
          "id": "10faadf0518ab62c7a8779ce52d05aa7",
          "title": "Machine Tool",
          "elements": [
            {
              "id": "ff406d558402c9c5ce7cdaf470a19fd8",
              "type": 0,
              "label": "Operation Mode",
              "valueVariable": {
                "variablePath": "1:Monitoring.1:MachineTool.1:OperationMode",
                "dataType": "Enum",
                "enumValues": {
                  "0": "Manual",
                  "1": "Automatic",
                  "2": "Setup",
                  "3": "AutoWithManualIntervention",
                  "4": "Service",
                  "5": "Other"
                }
              }
            },
            {
              "id": "fc1883335d98c7cfeb7f82b45f89a14b",
              "type": 0,
              "label": "Power On Duration",
              "valueVariable": {
                "variablePath": "1:Monitoring.1:MachineTool.1:PowerOnDuration",
                "dataType": "UInt32"
              }
            },
            {
              "id": "bb7e79a6e02999a0ec7043f7ffa012a8",
              "type": 1,
              "label": "Feed Override",
              "valueVariable": {
                "variablePath": "1:Monitoring.1:MachineTool.1:FeedOverride",
                "dataType": "Double",
                "hasUnit": true,
                "hasRange": true
              }
            }
          ]
        },
        {
          "id": "3c68a78b241749f874ee0abe254df0f5",
          "placeholders": [
            {
              "variablePath": "1:Monitoring",
              "reference": "47",
              "type": "1:16"
            }
          ],
          "title": "Channels",
          "titleVariable": {
            "variablePath": "1:Name",
            "dataType": "String"
          },
          "elements": [
            {
              "id": "595600c629185b88e1c96140899891c8",
              "type": 0,
              "label": "Channel Mode",
              "valueVariable": {
                "variablePath": "1:ChannelMode",
                "dataType": "Enum",
                "enumValues": {
                  "0": "Automatic",
                  "1": "MdaMdi",
                  "2": "JogManual",
                  "3": "JogIncrement",
                  "4": "TeachingHandle",
                  "5": "Remote",
                  "6": "Reference",
                  "7": "Other"
                }
              }
            },
            {
              "id": "13335faaf134f516b6f58d687c5cda8c",
              "type": 0,
              "label": "Channel State",
              "valueVariable": {
                "variablePath": "1:ChannelState",
                "dataType": "Enum",
                "enumValues": {
                  "0": "Active",
                  "1": "Interrupted",
                  "2": "Reset"
                }
              }
            },
            {
              "id": "396d55bd5767411d87b38eeacb090b3b",
              "type": 0,
              "label": "Minimal Override",
              "valueVariable": {
                "variablePath": "1:FeedOverride.EURange",
                "property": "Low",
                "dataType": "Double"
              }
            },
            {
              "id": "0db130f14d3a7c3ef3ae09a84450737d",
              "type": 0,
              "label": "Maximal Override",
              "valueVariable": {
                "variablePath": "1:FeedOverride.EURange",
                "property": "High",
                "dataType": "Double"
              }
            },
            {
              "id": "035f2d87316b52e4f3625280c4bfc379",
              "type": 1,
              "label": "Feed Override",
              "valueVariable": {
                "variablePath": "1:FeedOverride",
                "dataType": "Double",
                "hasUnit": true,
                "hasRange": true
              }
            }
          ]
        },
        {
          "id": "6f475c3e6a40568c2a00914b3eb003a2",
          "placeholders": [
            {
              "variablePath": "1:Monitoring",
              "reference": "47",
              "type": "1:22"
            }
          ],
          "title": "Spindles",
          "titleVariable": {
            "variablePath": "1:Name",
            "dataType": "String"
          },
          "elements": [
            {
              "id": "aaf7d739bbf783e5062bd646461346b8",
              "type": 0,
              "label": "State (is rotating)",
              "valueVariable": {
                "variablePath": "1:IsRotating",
                "dataType": "Boolean"
              }
            },
            {
              "id": "dcb98a56a138a506dbde45252fe373df",
              "type": 0,
              "label": "State (is used as axis)",
              "valueVariable": {
                "variablePath": "1:IsUsedAsAxis",
                "dataType": "Boolean"
              }
            },
            {
              "id": "b2090d274f75e0c1943c2eba786d6ae7",
              "type": 1,
              "label": "Override",
              "valueVariable": {
                "variablePath": "1:Override",
                "dataType": "Double",
                "hasUnit": true,
                "hasRange": true
              }
            }
          ]
        }
      ]
    },
    {
      "id": "6e752e96-cb43-47dd-a076-71ba2e7dea1e",
      "title": "Energy Monitoring",
      "optional": true,
      "validationNodePath": "1:Monitoring.2:Consumption.6:Electricity",
      "rows": [
        {
          "id": "Electricity",
          "title": "Electricity",
          "optional": true,
          "validationNodePath": "1:Monitoring.2:Consumption.6:Electricity",
          "elements": [
            {
              "id": "35d0d068-8621-45e9-9ed9-4b4d628db060",
              "type": 0,
              "isPlaceholder": false,
              "label": "L1 Voltage",
              "valueVariable": {
                "variablePath": "1:Monitoring.2:Consumption.6:Electricity.6:Main.5:AcVoltagePe",
                "dataType": "Structure",
                "field": "L1",
                "optional": true,
                "hasUnit": true,
                "hasRange": false
              }
            },
            {
              "id": "5214da4f-468e-417c-92bb-e1ee4e7c8dd0",
              "type": 0,
              "isPlaceholder": false,
              "label": "L1 Current",
              "valueVariable": {
                "displayName": "AcCurrentPe",
                "variablePath": "1:Monitoring.2:Consumption.6:Electricity.6:Main.5:AcCurrentPe",
                "dataType": "Structure",
                "field": "L1",
                "hasUnit": true,
                "optional": true,
                "hasRange": false
              }
            },
            {
              "id": "5b1af628-1a25-4c6f-83d6-abd702078a49",
              "type": 1,
              "isPlaceholder": false,
              "label": "L1 Power",
              "valueVariable": {
                "displayName": "AcActivePowerPe",
                "variablePath": "1:Monitoring.2:Consumption.6:Electricity.6:Main.5:AcActivePowerPe",
                "dataType": "Structure",
                "field": "L1",
                "hasUnit": true,
                "optional": true,

                "hasRange": false
              },
              "customRangeHigh": 1000,
              "customRangeLow": 0
            },
            {
              "id": "9c5efa5d-1ad0-4f04-b7c1-bbc3c05184fc",
              "type": 0,
              "isPlaceholder": false,
              "label": "L2 Voltage",
              "valueVariable": {
                "variablePath": "1:Monitoring.2:Consumption.6:Electricity.6:Main.5:AcVoltagePe",
                "dataType": "Structure",
                "optional": true,

                "field": "L2",
                "hasUnit": true,
                "hasRange": false
              }
            },
            {
              "id": "3bb7baa2-4883-4081-bfbc-5828f53f4f66",
              "type": 0,
              "isPlaceholder": false,
              "label": "L2 Current",
              "valueVariable": {
                "displayName": "AcCurrentPe",
                "variablePath": "1:Monitoring.2:Consumption.6:Electricity.6:Main.5:AcCurrentPe",
                "dataType": "Structure",
                "optional": true,

                "field": "L2",
                "hasUnit": true,
                "hasRange": false
              }
            },
            {
              "id": "c50632b5-7520-4cbc-a4a5-6ccc087a7ff2",
              "type": 1,
              "isPlaceholder": false,
              "label": "L2 Power",
              "valueVariable": {
                "displayName": "AcActivePowerPe",
                "variablePath": "1:Monitoring.2:Consumption.6:Electricity.6:Main.5:AcActivePowerPe",
                "dataType": "Structure",
                "optional": true,

                "field": "L2",
                "hasUnit": true,
                "hasRange": false
              },
              "customRangeHigh": 1000,
              "customRangeLow": 0
            },
            {
              "id": "79c4c6cc-18ad-4afa-a93c-81726ae84543",
              "type": 0,
              "isPlaceholder": false,
              "label": "L3 Voltage",
              "valueVariable": {
                "variablePath": "1:Monitoring.2:Consumption.6:Electricity.6:Main.5:AcVoltagePe",
                "dataType": "Structure",
                "optional": true,

                "field": "L3",
                "hasUnit": true,
                "hasRange": false
              }
            },
            {
              "id": "e7b41250-47cd-49d5-ae98-4b87a173f495",
              "type": 0,
              "isPlaceholder": false,
              "label": "L3 Current",
              "valueVariable": {
                "displayName": "AcCurrentPe",
                "variablePath": "1:Monitoring.2:Consumption.6:Electricity.6:Main.5:AcCurrentPe",
                "dataType": "Structure",
                "optional": true,

                "field": "L3",
                "hasUnit": true,
                "hasRange": false
              }
            },
            {
              "id": "6db63a51-c700-4626-87ef-4fe29d13419d",
              "type": 1,
              "isPlaceholder": false,
              "label": "L3 Power",
              "valueVariable": {
                "displayName": "AcActivePowerPe",
                "variablePath": "1:Monitoring.2:Consumption.6:Electricity.6:Main.5:AcActivePowerPe",
                "dataType": "Structure",
                "optional": true,

                "field": "L3",
                "hasUnit": true,
                "hasRange": false
              },
              "customRangeHigh": 1000,
              "customRangeLow": 0
            },
            {
              "id": "6c668e73-796d-414b-9393-90b02ba214a1",
              "type": 0,
              "isPlaceholder": false,
              "label": "Imported Energy",
              "valueVariable": {
                "displayName": "AcActiveEnergyTotalImportHp",
                "variablePath": "1:Monitoring.2:Consumption.6:Electricity.6:Main.5:AcActiveEnergyTotalImportHp",
                "dataType": "Double",
                "optional": true,

                "hasUnit": true,
                "hasRange": false
              }
            }
          ]
        },
        {
          "id": "CompressedAir",
          "title": "Compressed Air",
          "optional": true,
          "validationNodePath": "1:Monitoring.2:Consumption.6:CompressedAir",
          "elements": [
            {
              "id": "0f73fcb1-dc39-4b63-b52c-529be537b413",
              "type": 0,
              "isPlaceholder": false,
              "label": "Volume Flow Rate",
              "valueVariable": {
                "variablePath": "1:Monitoring.2:Consumption.6:CompressedAir.6:Main.5:VolumeFlowRate",
                "dataType": "Float",
                "optional": true,

                "hasUnit": true,
                "hasRange": false
              }
            },
            {
              "id": "9aeeba2e-077c-4217-82cb-6b8398a85640",
              "type": 0,
              "isPlaceholder": false,
              "label": "Pressue",
              "valueVariable": {
                "variablePath": "1:Monitoring.2:Consumption.6:CompressedAir.6:Main.5:Pressure",
                "dataType": "Float",
                "hasUnit": true,
                "optional": true,

                "hasRange": false
              }
            },
            {
              "id": "2f2853ac-d6dc-441a-8c41-2657f06d50d6",
              "type": 0,
              "isPlaceholder": false,
              "label": "Temperature",
              "valueVariable": {
                "variablePath": "1:Monitoring.2:Consumption.6:CompressedAir.6:Main.5:Temperature",
                "dataType": "Float",
                "hasUnit": true,
                "optional": true,
                "hasRange": false
              }
            }
          ]
        },
        {
          "id": "ChilledWater",
          "title": "Chilled Water",
          "optional": true,
          "validationNodePath": "1:Monitoring.2:Consumption.6:ChilledWater",
          "elements": [
            {
              "id": "8ead4d64-07d9-417d-9299-74483eb184e7",
              "type": 0,
              "isPlaceholder": false,
              "label": "Volume Flow Rate",
              "valueVariable": {
                "variablePath": "1:Monitoring.2:Consumption.6:ChilledWater.6:Main.5:VolumeFlowRate",
                "dataType": "Float",
                "hasUnit": true,
                "optional": true,
                "hasRange": false
              }
            },
            {
              "id": "a0326658-d6cc-4212-a0c7-704eda629f68",
              "type": 0,
              "isPlaceholder": false,
              "label": "Pressue",
              "valueVariable": {
                "variablePath": "1:Monitoring.2:Consumption.6:ChilledWater.6:Main.5:Pressure",
                "dataType": "Float",
                "hasUnit": true,
                "optional": true,
                "hasRange": false
              }
            },
            {
              "id": "142de2a6-dfb8-4d22-a864-04604ab1d265",
              "type": 0,
              "isPlaceholder": false,
              "label": "Temperature",
              "valueVariable": {
                "variablePath": "1:Monitoring.2:Consumption.6:ChilledWater.6:Main.5:Temperature",
                "dataType": "Float",
                "hasUnit": true,
                "optional": true,
                "hasRange": false
              }
            }
          ]
        }
      ]
    }
  ]
}
